import { defineMessages } from 'react-intl';

export const messages: {
	jira_quick_find_single_site_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_projects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_spaces: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_boards: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_filters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_plans: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_people: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_work_items: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	jira_quick_find_single_site_label: {
		id: 'jira_single_site_label',
		defaultMessage: 'Go to all:',
		description:
			'Label for when the user wants to navigate to a single site on Jira via the search query',
	},
	jira_quick_find_projects: {
		id: 'jira_single_site_projects',
		defaultMessage: 'Projects',
		description:
			'Navigation link label shown in the Jira single-site Quick Find results for navigating to all Jira projects.',
	},
	jira_quick_find_spaces: {
		id: 'jira_single_site_spaces',
		defaultMessage: 'Spaces',
		description:
			'Navigation link label shown in the Jira single-site Quick Find results for navigating to all Confluence spaces.',
	},
	jira_quick_find_boards: {
		id: 'jira_single_site_boards',
		defaultMessage: 'Boards',
		description:
			'Navigation link label shown in the Jira single-site Quick Find results for navigating to all Jira boards.',
	},
	jira_quick_find_filters: {
		id: 'jira_single_site_filters',
		defaultMessage: 'Filters',
		description:
			'Navigation link label shown in the Jira single-site Quick Find results for navigating to all saved Jira filters.',
	},
	jira_quick_find_plans: {
		id: 'jira_single_site_plans',
		defaultMessage: 'Plans',
		description:
			'Navigation link label shown in the Jira single-site Quick Find results for navigating to all Jira plans.',
	},
	jira_quick_find_people: {
		id: 'jira_single_site_people',
		defaultMessage: 'Teams',
		description:
			'Navigation link label shown in the Jira single-site Quick Find results for navigating to teams. Jira uses "Teams" to refer to people.',
	},
	jira_quick_find_work_items: {
		id: 'jira_single_site_work_items_jql',
		defaultMessage: 'Work items (JQL)',
		description: 'Label for the Work items navigation button in Jira single site search',
	},
});
